<template>
	<iframe class="shom" :src="`/data/shom/${port}.html`" v-on:load="resizeHeight($event)"></iframe>
</template>

<script>
export default {
  name: 'Shom',
  props: ['port'],

  methods: {
  	resizeHeight(e) {
  		var iframe = e.target
  		iframe.style.height = iframe.contentWindow.document.body.scrollHeight + 'px'
  	}
  }
}
</script>

<style lang="scss">
	.shom {
		width: 100%;
		height: max-content;
	}

  iframe {
    background-color: white;
    border: 0;
  }
</style>

/** 
 * html du widget shom hébergé sur le même domaine pour simplifier le problème de récupération de la hauteur 
 */